import React, { useEffect, useState } from "react";

import ProductSelectionPanel from "./ProductSelection/ProductSelectionPanel";
import { Card, Col, Row } from "react-bootstrap";
import CustomerPanel from "./CustomerPanel/CustomerPanel";

import {
    Pencil,
    Trash,
    Eye
} from "react-bootstrap-icons";

import DataTable from "../../../Components/DataTable/DataTable";

const NewInvoice = () => {

    const [invoiceData, setInvoiceData] = useState({});
    const productGroups = [
        {
            id: 1,
            name: "موبایل"
        },
        {
            id: 2,
            name: "لپ‌تاپ"
        },
        {
            id: 3,
            name: "لوازم جانبی"
        }
    ];

    const searchProducts = async ({
        groupId,
        searchType,
        searchText
    }) => {

        /*
         * این قسمت را با API واقعی پروژه جایگزین کنید.
         *
         * مثال:
         *
         * const response = await axios.get(
         *     "/api/products/search",
         *     {
         *         params: {
         *             groupId,
         *             searchType,
         *             searchText
         *         }
         *     }
         * );
         *
         * return response.data;
         */

        console.log({
            groupId,
            searchType,
            searchText
        });

        return [];
    };

    const handleProductSelect = (
        product,
        quantity
    ) => {

        console.log(
            "Selected Product:",
            product
        );

        console.log(
            "Quantity:",
            quantity
        );

        /*
         * عملیات موردنظر شما:
         *
         * افزودن به فاکتور
         * افزودن به سبد
         * انتخاب برای ثبت سند
         * و ...
         */
    };
    useEffect(() => {
        document.body.classList = "notMain";
    }, [])


    const departments = [
        {
            id: 1,
            name: "فروش"
        },
        {
            id: 2,
            name: "مالی"
        },
        {
            id: 3,
            name: "منابع انسانی"
        },
        {
            id: 4,
            name: "فنی"
        }
    ];

    const [data, setData] = useState([
        {
            id: 1,
            name: "Ali Ahmadi",
            age: 25,
            salary: 1250000,
            departmentId: 4,
            isActive: true,
            description:
                "کارشناس ارشد توسعه نرم‌افزار"
        },

        {
            id: 2,
            name: "Reza Mohammadi",
            age: 31,
            salary: 2500000,
            departmentId: 2,
            isActive: false,
            description:
                "کارشناس واحد مالی شرکت"
        },

        {
            id: 3,
            name: "Sara Hosseini",
            age: 28,
            salary: 3200000,
            departmentId: 1,
            isActive: true,
            description:
                "مدیر فروش و توسعه بازار"
        },

        {
            id: 4,
            name: "Mehdi Karimi",
            age: 42,
            salary: 4500000,
            departmentId: 3,
            isActive: true,
            description:
                "مدیر منابع انسانی سازمان"
        },

        {
            id: 5,
            name: "Nima Ahmadi",
            age: 35,
            salary: 3800000,
            departmentId: 4,
            isActive: true,
            description:
                "توسعه‌دهنده ارشد Backend"
        }
    ]);

    /*
     * --------------------------------------
     * Columns
     * --------------------------------------
     */

    const columns = [
        {
            field: "name",
            title: "نام",
            type: "string",
            required: true
        },

        {
            field: "description",
            title: "توضیحات",
            type: "string",
            maxLength: 90
        },

        {
            field: "age",
            title: "سن",
            type: "number",

            required: true,

            validate: value => {
                if (value < 18) {
                    return "سن باید حداقل 18 باشد";
                }

                if (value > 100) {
                    return "سن نمی‌تواند بیشتر از 100 باشد";
                }

                return null;
            }
        },

        {
            field: "salary",
            title: "حقوق",
            type: "number"
        },

        {
            field: "departmentId",
            title: "دپارتمان",
            type: "dropdown",

            dataSource: departments,

            valueField: "id",
            textField: "name",

            placeholder:
                "انتخاب دپارتمان...",

            required: true
        },

        {
            field: "isActive",
            title: "فعال",
            type: "bool"
        }
    ];

    /*
     * --------------------------------------
     * Actions
     * --------------------------------------
     */

    const actions = [
        {
            title: "ویرایش",
            icon: <Pencil />,
            type: "edit"
        },

        {
            title: "حذف",
            icon: <Trash />,

            onClick: row => {
                console.log(
                    "delete:",
                    row
                );
            },

            visible: row =>
                row.isActive === true
        }
    ];

    /*
     * --------------------------------------
     * Controlled Save
     * --------------------------------------
     */

    const handleEditSave = async (
        updatedRow,
        originalRow
    ) => {
        console.log(
            "updated:",
            updatedRow
        );

        console.log(
            "original:",
            originalRow
        );

        /*
         * Example:
         *
         * await api.update(updatedRow);
         *
         * DataTable itself does not know
         * anything about API.
         */

        setData(prev =>
            prev.map(row => {
                const rowId =
                    row.id;

                const updatedId =
                    updatedRow.id;

                return rowId ===
                    updatedId
                    ? {
                        ...updatedRow
                    }
                    : row;
            })
        );
    };



    return (
        <div className="container-fluid">
            <Card>
                <Card.Header className="headerStyle">فاکتور سریع</Card.Header>
                <Card.Body className="bodyStyle">
                    <Row >
                        <Col md={4} className="rowBorder p-1">
                            <ProductSelectionPanel
                                productGroups={productGroups}
                                searchProducts={searchProducts}
                                onProductSelect={handleProductSelect}
                            />
                        </Col>
                        <Col md={8}>
                            < div className="rowBorder p-1">
                                <CustomerPanel invoiceData={invoiceData} setInvoiceData={setInvoiceData} />
                            </div>
                            <div
                                dir="rtl"
                                className="p-3"
                            >
                                <DataTable
                                    data={data}
                                    columns={columns}
                                    actions={actions}
                                    rowKey="id"
                                    editable={true}
                                    editMode="row"
                                    locale="en-US"
                                    loading={false}
                                    emptyMessage="داده‌ای برای نمایش وجود ندارد"
                                    onEditSave={
                                        handleEditSave
                                    }
                                />
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
};

export default NewInvoice;
